import type { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { type ApTabValue, invoiceReviewPath } from "@/accounts-payable/utils";
import { cn } from "@/core/utils/utils";

/** Only the invoice number is interactive, so card actions cannot open it. */
export const InvoiceCardTitleLink = ({
  invoiceId,
  vendorName,
  invoiceNumber,
  fromTab,
  className,
  onClick,
}: {
  invoiceId: string;
  vendorName: string;
  invoiceNumber: string;
  fromTab: ApTabValue;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}) => (
  <Link
    to={invoiceReviewPath(invoiceId, fromTab)}
    onClick={onClick}
    aria-label={`Review ${vendorName} invoice ${invoiceNumber}`}
    className={cn(
      "rounded-sm underline underline-offset-2 hover:text-interactive-text focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
      className,
    )}
  >
    {invoiceNumber}
  </Link>
);
